import { Schema } from 'further-types/investor';
import { signUpSourcesThatSkipOnboarding } from 'further-ui/config';

const isOnboardingCompleteOrSkipped = (
  isSubdomain: boolean,
  user?: {
    signUpSource: Schema.SignUpSource;
    isOnbordingComplete: boolean;
  },
) => {
  // always skip onboarding on the green site - it won't work as classification is now per firm
  if (!isSubdomain) {
    return true;
  }

  return user
    ? user?.isOnbordingComplete ||
        signUpSourcesThatSkipOnboarding.includes(user?.signUpSource)
    : false;
};

export default isOnboardingCompleteOrSkipped;
